import LessonOneIcon from '../../../assets/svg-components/lesson_1.svg';
import LessonTwoIcon from '../../../assets/svg-components/lesson_2.svg';
import LessonThreeIcon from '../../../assets/svg-components/lesson_3.svg';
import LessonFourIcon from '../../../assets/svg-components/lesson_4.svg';
import LessonFiveIcon from '../../../assets/svg-components/lesson_5.svg';
import LessonSixIcon from '../../../assets/svg-components/lesson_6.svg';
import LessonSevenIcon from '../../../assets/svg-components/lesson_7.svg';
import LessonEightIcon from '../../../assets/svg-components/lesson_8.svg';
import LessonNineIcon from '../../../assets/svg-components/lesson_9.svg';
import LessonTenIcon from '../../../assets/svg-components/lesson_10.svg';
import LessonElevenIcon from '../../../assets/svg-components/lesson_11.svg';
import LessonTwelveIcon from '../../../assets/svg-components/lesson_12.svg';
import LessonThirteenIcon from '../../../assets/svg-components/lesson_13.svg';
import LessonFourteenIcon from '../../../assets/svg-components/lesson_14.svg';
import LessonFifteenIcon from '../../../assets/svg-components/lesson_15.svg';
import LessonSixteenIcon from '../../../assets/svg-components/lesson_16.svg';
import LessonSeventeenIcon from '../../../assets/svg-components/lesson_17.svg';
import LessonEighteenIcon from '../../../assets/svg-components/lesson_18.svg';
import LessonNineteenIcon from '../../../assets/svg-components/lesson_19.svg';
import LessonTwentyIcon from '../../../assets/svg-components/lesson_20.svg';

const COLORS = {
  PURPLE: '#D1A2F5',
  YELLOW: '#FFF2AA',
  CORAL: '#FCB6CC',
  BLUE: '#C6D4F4',
  MINT: '#98E5B9'
};

export const CARD_CONFIG = {
  DREAM_BIG: {
    label: 'translate.cards.lesson.one.label',
    labelColor: COLORS.PURPLE,
    title: 'translate.cards.lesson.one.title',
    icon: LessonOneIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/01_dream.png'
  },
  GAME_CHANGER: {
    label: 'translate.cards.lesson.two.label',
    labelColor: COLORS.YELLOW,
    title: 'translate.cards.lesson.two.title',
    icon: LessonTwoIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/02_begamechanger.png'
  },
  EXTRA_MILE: {
    label: 'translate.cards.lesson.three.label',
    labelColor: COLORS.CORAL,
    title: 'translate.cards.lesson.three.title',
    icon: LessonThreeIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/03_goextramile.png'
  },
  CARD_4: {
    label: 'translate.cards.lesson.four.label',
    labelColor: COLORS.BLUE,
    title: 'translate.cards.lesson.four.title',
    icon: LessonFourIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/04_givemore.png'
  },
  CARD_5: {
    label: 'translate.cards.lesson.five.label',
    labelColor: COLORS.MINT,
    title: 'translate.cards.lesson.five.title',
    icon: LessonFiveIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/05_people.png'
  },
  CARD_6: {
    label: 'translate.cards.lesson.six.label',
    labelColor: COLORS.PURPLE,
    title: 'translate.cards.lesson.six.title',
    icon: LessonSixIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/06_findyourcommunity.png'
  },
  CARD_7: {
    label: 'translate.cards.lesson.seven.label',
    labelColor: COLORS.YELLOW,
    title: 'translate.cards.lesson.seven.title',
    icon: LessonSevenIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/07_workhard.png'
  },
  CARD_8: {
    label: 'translate.cards.lesson.eight.label',
    labelColor: COLORS.CORAL,
    title: 'translate.cards.lesson.eight.title',
    icon: LessonEightIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/08_earlyadoption.png'
  },
  CARD_9: {
    label: 'translate.cards.lesson.nine.label',
    labelColor: COLORS.BLUE,
    title: 'translate.cards.lesson.nine.title',
    icon: LessonNineIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/09_dontgoeasy.png'
  },
  CARD_10: {
    label: 'translate.cards.lesson.ten.label',
    labelColor: COLORS.MINT,
    title: 'translate.cards.lesson.ten.title',
    icon: LessonTenIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/10_movebusiness.png'
  },
  CARD_11: {
    label: 'translate.cards.lesson.eleven.label',
    labelColor: COLORS.PURPLE,
    title: 'translate.cards.lesson.eleven.title',
    icon: LessonElevenIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/11_putpeoplefirst.png'
  },
  CARD_12: {
    label: 'translate.cards.lesson.twelve.label',
    labelColor: COLORS.YELLOW,
    title: 'translate.cards.lesson.twelve.title',
    icon: LessonTwelveIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/12_listenclients.png'
  },
  CARD_13: {
    label: 'translate.cards.lesson.thirteen.label',
    labelColor: COLORS.CORAL,
    title: 'translate.cards.lesson.thirteen.title',
    icon: LessonThirteenIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/13_dontcutcorners.png'
  },
  CARD_14: {
    label: 'translate.cards.lesson.fourteen.label',
    labelColor: COLORS.BLUE,
    title: 'translate.cards.lesson.fourteen.title',
    icon: LessonFourteenIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/14_keepnofailure.png'
  },
  CARD_15: {
    label: 'translate.cards.lesson.fifteen.label',
    labelColor: COLORS.MINT,
    title: 'translate.cards.lesson.fifteen.title',
    icon: LessonFifteenIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/15_youcanonlytrustyourself.png'
  },
  CARD_16: {
    label: 'translate.cards.lesson.sixteen.label',
    labelColor: COLORS.PURPLE,
    title: 'translate.cards.lesson.sixteen.title',
    icon: LessonSixteenIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/16_investclients.png'
  },
  CARD_17: {
    label: 'translate.cards.lesson.seventeen.label',
    labelColor: COLORS.YELLOW,
    title: 'translate.cards.lesson.seventeen.title',
    icon: LessonSeventeenIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/17_solverealproblems.png'
  },
  CARD_18: {
    label: 'translate.cards.lesson.eighteen.label',
    labelColor: COLORS.CORAL,
    title: 'translate.cards.lesson.eighteen.title',
    icon: LessonEighteenIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/18_mindyourfootprint.png'
  },
  CARD_19: {
    label: 'translate.cards.lesson.nineteen.label',
    labelColor: COLORS.BLUE,
    title: 'translate.cards.lesson.nineteen.title',
    icon: LessonNineteenIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/19_thinkforward.png'
  },
  CARD_20: {
    label: 'translate.cards.lesson.twenty.label',
    labelColor: COLORS.MINT,
    title: 'translate.cards.lesson.twenty.title',
    icon: LessonTwentyIcon,
    backfaceIconSRC: 'https://www.siteground.com/static/2024/en/img/web/sg_birthday/20_usesuccess.png'
  }
};
